<template>
  <client-only>
    <Suspense @resolve="onResolve">
      <div ref="bookingCardEl" :class="wrapperClass">
        <BookingBranchCard id="main-booking-card" :branch="branch" />
      </div>

      <template #fallback>
        <v-skeleton-loader :class="skeletonClass" type="ossein" />
      </template>
    </Suspense>
    <template #fallback>
      <v-skeleton-loader :class="skeletonClass" type="ossein" />
    </template>
  </client-only>
</template>

<script setup lang="ts">
import type { BranchDetail } from '@/types/api'

interface Props {
  branch: Required<Pick<BranchDetail, 'bid' | 'name' | 'reserve_mode'>>
  wrapperClass?: ClassType
  skeletonClass?: ClassType
}

interface Emits {
  resolve: []
}

const BookingBranchCard = defineAsyncComponent(() => import('@/components/card/booking-branch-card.vue'))

defineProps<Props>()

const emit = defineEmits<Emits>()

const bookingCardEl = useTemplateRef<HTMLElement>('bookingCardEl')

function onResolve() {
  // Suspense `@resolve` 發生在 DOM patch 之前，故 ref 還無值，需需等下個 DOM commit 才有值。
  nextTick(() => emit('resolve'))
}

defineExpose({ bookingCardEl })
</script>
